"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const react_loops_1 = require("react-loops");
const BlockCanvas_1 = require("../../../../BlockCanvas");
exports.EmailCanvasBlocksEditor = ({ blocks, onChange, showNoBlocksWarning = true, parentBlock, indexPath, parentIsLocked, parentIsHidden, parentIsVisible, conversionPanelConversions, }) => {
    if (!showNoBlocksWarning && (!blocks || blocks.length === 0)) {
        return react_2.default.createElement(react_2.default.Fragment, null);
    }
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "EmailCanvasBlocksEditor", flexColFilled: true },
        react_2.default.createElement(react_loops_1.For, { of: blocks, ifEmpty: react_2.default.createElement(react_1.OsmosysUndesiredState, { message: "No blocks found" }) }, (block, { isFirst, isLast, index }) => {
            const iPath = indexPath ? [...indexPath, index] : [index];
            const idxPath = iPath.join(':');
            return (react_2.default.createElement(BlockCanvas_1.BlockCanvas, { conversionStatus: conversionPanelConversions[idxPath], isFirst: isFirst, isLast: isLast, key: block.id, index: index, block: block, parentIsLocked: !!parentIsLocked, parentIsHidden: !!parentIsHidden, parentIsVisible: parentIsVisible, parentBlock: parentBlock, indexPath: iPath, onChange: newBlock => {
                    const newBlocks = [...blocks];
                    newBlocks[index] = Object.assign(Object.assign({}, newBlocks[index]), newBlock);
                    onChange(newBlocks);
                } }));
        })));
};
//# sourceMappingURL=index.js.map